import {
  BookingScheduleInterface,
  VisitConsentSummary
} from "../../Booking-Form/typings/booking.types";

export type { VisitConsentSummary };

/**
 * When `visitConsent` is absent, the API does not expose consent detail — skip the override dialog.
 * When documents are listed: confirm check-in if any document is not consented, or signature is known missing.
 */
export function shouldConfirmCheckInWithoutConsent(
  visit: Pick<BookingScheduleInterface, "visitConsent">
): boolean {
  const summary = visit.visitConsent;
  if (!summary) {
    return false;
  }
  const documents = summary.documents;
  if (!documents?.length) {
    return false;
  }
  const allDocsConsented = documents.every(d => d.consented);
  if (!allDocsConsented) {
    return true;
  }
  return summary.signatureStored === false;
}

export function isVisitConsentDataAvailable(
  visit: Pick<BookingScheduleInterface, "visitConsent">
): boolean {
  return Boolean(visit.visitConsent?.documents?.length);
}
